import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
//import { useStore } from 'vuex'
import zhCN from 'ant-design-vue/es/locale/zh_CN';

//const store = useStore();

export default {
  __name: 'App',
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view);
    };
  }
};